"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiReportPayoutResponseDto = void 0;
const types_1 = require("../../../billing-api-contractor/types");
const billing_api_report_payout_stripe_response_dto_1 = require("./billing-api-report-payout-stripe-response.dto");
const billing_api_report_payout_tinkoff_response_dto_1 = require("./billing-api-report-payout-tinkoff-response.dto");
const class_transformer_1 = require("class-transformer");
const types_2 = require("../../../billing-api-payout/types");
const swagger_1 = require("../../../../swagger-fake");
const billing_core_payout_status_enum_1 = require("../../../../billing-core/billing-core-payout/types/enums/billing-core-payout-status.enum");
let BillingApiReportPayoutResponseDto = class BillingApiReportPayoutResponseDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "ID выплаты"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportPayoutResponseDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Контрагент"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", types_1.BillingApiContractorResponseDto)], BillingApiReportPayoutResponseDto.prototype, "contractor", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Счёт на который производится выплата"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportPayoutResponseDto.prototype, "toAccount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сумма",
  format: "decimal",
  example: "15.00"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportPayoutResponseDto.prototype, "amount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Код валюты выплаты",
  example: "USD"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportPayoutResponseDto.prototype, "currencyCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Код траны в которую производится выплата",
  example: "US"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportPayoutResponseDto.prototype, "countryCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Статус",
  enum: billing_core_payout_status_enum_1.BillingCorePayoutStatusEnum
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportPayoutResponseDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата последней попытки выплаты",
  nullable: true
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportPayoutResponseDto.prototype, "lastAttemptAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Количество попыток выплаты",
  nullable: true
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportPayoutResponseDto.prototype, "attempts", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Список ошибок (если есть)",
  nullable: true,
  enum: types_2.BillingApiPayoutStatusEnum
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportPayoutResponseDto.prototype, "errors", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сведения характерные для конкретного мерчант-провайдера",
  oneOf: [{
    $ref: (0, swagger_1.getSchemaPath)(billing_api_report_payout_stripe_response_dto_1.BillingApiReportPayoutStripeResponseDto)
  }, {
    $ref: (0, swagger_1.getSchemaPath)(billing_api_report_payout_tinkoff_response_dto_1.BillingApiReportPayoutTinkoffResponseDto)
  }]
}), (0, class_transformer_1.Expose)(), (0, class_transformer_1.Type)(() => Object, {
  discriminator: {
    property: '__type',
    subTypes: [{
      value: billing_api_report_payout_stripe_response_dto_1.BillingApiReportPayoutStripeResponseDto,
      name: billing_api_report_payout_stripe_response_dto_1.BillingApiReportPayoutStripeResponseDto.name
    }, {
      value: billing_api_report_payout_tinkoff_response_dto_1.BillingApiReportPayoutTinkoffResponseDto,
      name: billing_api_report_payout_tinkoff_response_dto_1.BillingApiReportPayoutTinkoffResponseDto.name
    }]
  }
}), __metadata("design:type", Object)], BillingApiReportPayoutResponseDto.prototype, "merchant", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата и время операции",
  format: "date-time"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Date)], BillingApiReportPayoutResponseDto.prototype, "createdAt", void 0);
BillingApiReportPayoutResponseDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiReportPayoutResponseDto);
exports.BillingApiReportPayoutResponseDto = BillingApiReportPayoutResponseDto;
